const locale = {
	USER_DISABLED: 'Accesso disabilitato',

	DETAILS_USERS_TAB_ACTIVITIES_KANBAN: 'Kanban Attività',
	DETAILS_USERS_TAB_OPPORTUNITIES_KANBAN: 'Kanban Opportunità',

	// #region User fields
	DETAILS_USERS_FIELD_NAME: 'Nome',
	DETAILS_USERS_FIELD_SURNAME: 'Cognome',
	DETAILS_USERS_FIELD_MAIL: 'Indirizzo Email Login',
	DETAILS_USERS_FIELD_RECRUITMENT_DATE: 'Data assunzione',
	DETAILS_USERS_FIELD_RETIREMENT_DATE: 'Data conclusione rapporto',
	DETAILS_USERS_FIELD_BIRTHDAY: 'Data di nascita',
	DETAILS_USERS_FIELD_ROLES: 'Ruoli Utente',
	DETAILS_USERS_FIELD_QUALIFICATION: 'Titolo di studio',
	DETAILS_USERS_FIELD_TAXCODE: 'Codice fiscale',
	DETAILS_USERS_FIELD_HOURLY_RATE: 'Costo orario',
	DETAILS_USERS_FIELD_ADDRESS: 'Indirizzo',
	DETAILS_USERS_FIELD_ADDRESS_CITY: 'Città',
	DETAILS_USERS_FIELD_ADDRESS_ZIP: 'CAP',
	DETAILS_USERS_FIELD_ADDRESS_DISTRICT: 'Provincia',
	DETAILS_USERS_FIELD_ADDRESS_REGION: 'Regione',
	DETAILS_USERS_FIELD_ADDRESS_COUNTRY: 'Stato',
	DETAILS_USERS_FIELD_ADDRESS_ZONE: 'Zona',
	DETAILS_USERS_FIELD_ERP_ID: 'ERP - ID',
	DETAILS_USERS_FIELD_MES_ID: 'MES - ID',
	DETAILS_USERS_FIELD_PUNCH_CLOCK_BARCODE: 'Timbraore - Codice',
	DETAILS_USERS_FIELD_ENABLED: 'Abilitato',
	DETAILS_USERS_FIELD_USER_COMPANY: 'Azienda',
	USER_WORKDAY_TIME_START: 'Inizio orario giornata lavorativa',
	USER_WORKDAY_TIME_END: 'Fine orario giornata lavorativa',
	USER_LUNCH_TIME_START: 'Inizio orario pausa pranzo',
	USER_LUNCH_TIME_END: 'Fine orario pausa pranzo',

	DETAILS_USERS_SECTION_USE_EXISTING: 'Usa Utente esistente',
	DETAILS_USERS_SECTION_ADD_NEW: 'Aggiungi nuovo Utente',
	DETAILS_USERS_FIELD_PASSWORD: 'Password',
	DETAILS_USERS_FIELD_CONFIRM_PASSWORD: 'Conferma Password',
	DETAILS_USERS_FIELD_FORCE_RESET_PASSWORD: 'Deve cambiare password',
	DETAILS_USERS_CHANGE_PASSWORD_TEXT: 'Per modificare la password vai in modalità modifica',
	DETAILS_USERS_FIELD_ROLE: 'Ruolo Utente',
	// #endregion

	// #region Details Address section
	DETAILS_USERS_ADDRESS_RESIDENCE_SECTION: 'Indirizzo residenza',
	DETAILS_USERS_ADDRESS_RESIDENCE_SUBHEADER: "Visualizza e modifica l'indirizzo di residenza",

	DETAILS_USERS_ADDRESS_DOMICILE_SECTION: 'Indirizzo domicilio',
	DETAILS_USERS_ADDRESS_DOMICILE_SUBHEADER: "Visualizza e modifica l'indirizzo di domicilio",
	// #endregion

	// #region User Availability fields
	DETAILS_USERS_AVAILABILITY_FIELD_NAME: 'Utente',
	DETAILS_USERS_AVAILABILITY_STATUS: 'Stato Permesso',
	DETAILS_USERS_AVAILABILITY_FIELD_DATE_FROM: 'Data da',
	DETAILS_USERS_AVAILABILITY_FIELD_DATE_TO: 'Data a',
	DETAILS_USERS_AVAILABILITY_FIELD_GROUPS: 'Gruppo',
	// #endregion

	// #region User Avatar
	USERS_AVATAR_SECTION: 'Avatar',
	USERS_AVATAR_SUBHEADER: "Visualizza o aggiorna l'avatar del tuo profilo",
	// #endregion

	// #region Details system user creation
	USERS_SYSTEM_USER_CREATION_SECTION: 'Dati Utente Perceptive',
	USERS_SYSTEM_USER_CREATION_SUBHEADER: 'Usa un Utente Perceptive esistente o creane uno nuovo.',
	// #endregion

	// #region Details user system info
	USERS_APPSETTINGS_SECTION: 'Account Perceptive',
	USERS_APPSETTINGS_SUBHEADER: "Visualizza i dettagli dell'Account Perceptive",
	LOGIN_EMAIL: 'Indirizzo Mail Login',
	ROLE: 'Ruolo',
	LAST_LOGIN: 'Ultimo accesso',
	PASSWORD: 'Password',
	LOGIN_EMAIL_EDIT_BUTTON: 'Modifica Mail Login',

	DETAILS_USERS_STATUS_TITLE: 'Stato',
	DETAILS_USERS_STATUS_ACTIVE: 'ATTIVO',
	DETAILS_USERS_STATUS_DISABLED: 'DISATTIVATO',
	// #endregion

	// #region Change Login Mail Dialog
	DIALOG_LOGIN_MAIL_TITLE: 'Modifica Mail di Login',
	DIALOG_LOGIN_MAIL_DESCRIPTION1: 'Utilizza il campo "Mail" per modificare la mail di login.',
	DIALOG_LOGIN_MAIL_DESCRIPTION2: "Attenzione! L'indirizzo di login verrà modificato per tutte le App Perceptive.",
	DIALOG_LOGIN_EMAIL_FIELD: 'Mail',
	// #endregion

	// #region Details User Permissions section
	USERS_PERMISSIONS_SECTION: 'Permessi applicazione',
	USERS_PERMISSIONS_SUBHEADER: "Visualizza e modifica le impostazioni dei permessi dell'applicazione",
	NOT_SUPPORTED: 'Impostazione non supportata dal browser',
	PUSH_NOTIFICATIONS_SETTING: 'Notifiche push',
	SPEECH_TO_TEXT_SETTING: 'Dettatura',
	MAIL_NOTIFICATION_SETTING: 'Notifiche mail',
	// #endregion

	// #region Details User Saved Filters section
	USERS_SAVEDFILTERS_SECTION: 'Filtri salvati',
	USERS_SAVEDFILTERS_SUBHEADER: "Visualizza i filtri salvati dall'Utente",
	// #endregion

	// #region Details User buttons
	DETAILS_HEADER_BUTTON_NEW_COURSE: 'Aggiungi Corso',
	// #endregion

	TAB_ATTENDED_COURSES: 'Corsi frequentati',

	// #region User Daily Report
	USERS_DAILYREPORT_SECTION: 'Email di riepilogo giornaliera',
	USERS_DAILYREPORT_SUBHEADER: "Attiva/disattiva l'email di riepilogo giornaliera",

	DIALOG_TITLE_DAILY_REPORT_SETTINGS: 'Impostazioni email di riepilogo giornaliera',
	DAILY_REPORT_FIELD_TEMPLATE: 'Nome template',
	DAILY_REPORT_FIELD_CRON: 'Cron',

	DAILY_REPORT_TEMPLATE: 'Template: {template}',
	DAILY_REPORT_TYPE: 'Tipo: {type}',
	DAILY_REPORT_CREATEDAT: 'Creato il {date}',
	DAILY_REPORT_NEXTEXECUTION: 'Prossima esecuzione il {date}',
	DAILY_REPORT_RECURRENCE: 'Ricorrenza: "{cron}"',

	DAILY_REPORT_UNIT_WEEK: 'settimane',
	DAILY_REPORT_UNIT_DAY: 'giorni',
	DAILY_REPORT_UNIT_HOUR: 'ore',
	DAILY_REPORT_UNIT_MINUTE: 'minuti',
	// #endregion

	USER_LOGIN_LOGS: 'Log accessi'
};

export default locale;
